import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { Observable, map } from 'rxjs';
import { SubscriptionsModule } from '../../../tariffs/subscriptions/subscriptions.module';
import { KkmSettingsStateService } from '../services/kkm-settings-state.service';
import { ActivateSubscriptionModalInputData } from '../../../tariffs/activate-subscription-modal/open-activate-subscription-modal.directive';
import { TariffService } from '../../../../core/services/tariff.service';
import { SharedModule } from '../../../../shared/shared.module';
import { KkmSettingsNavigationService } from '../services/kkm-setting-navigation.service';
import { KkmAvailableOperations } from '../../../../core/modules/kkms/kkms.types';
import { IKkm } from '../../../../core/modules/retail-places/retail-paces.types';

@Component({
  selector: 'tax-kkm-tariff-management',
  templateUrl: './kkm-tariff-management.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    SubscriptionsModule,
    SharedModule,
  ],
})

export class KkmTariffManagementComponent implements OnInit {
  @Input() kkm?: IKkm & KkmAvailableOperations;
  activateSubscriptionModalInputData$?: Observable<ActivateSubscriptionModalInputData>;

  constructor(
    private kkmSettingsStateService: KkmSettingsStateService,
    private kkmSettingsNavigationService: KkmSettingsNavigationService,
    private tariffService: TariffService,
  ) {}

  ngOnInit(): void {
    if (this.kkm?.tariffId) {
      this.activateSubscriptionModalInputData$ = this.getActivateSubscriptionData(this.kkm.tariffId);
    }
  }

  updateKkmData(): void {
    this.kkmSettingsStateService.tariffActivated$.next();
  }

  goToSelectSubscriptionPage(kkmId: number): void {
    this.kkmSettingsNavigationService.navigateToSelectSubscriptionPage(kkmId);
  }

  private getActivateSubscriptionData(tariffId: number): Observable<ActivateSubscriptionModalInputData> {
    return this.tariffService.getTariffById(tariffId).pipe(
      map(tariff => ({
        tariff,
        kkmId: Number(this.kkm?.id),
      })),
    );
  }
}
